import script from "./pressPage.vue?vue&type=script&setup=true&lang=js"
export * from "./pressPage.vue?vue&type=script&setup=true&lang=js"

import "./pressPage.vue?vue&type=style&index=0&id=15823d60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15823d60"]])

export default __exports__